import { Box } from '@mui/material';
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import Layout from './Layout';
import AuthHead from './authhead';
import { BtnInput, CheckInput, DontHave, EmailInput, NameInput, PasswordInput } from './inputs';
import { useChangeAuthType } from '@/util/hooks/changeAuth';

export default function Register() {
    const {classes}=styles();
    const changeAuthType = useChangeAuthType();
  return (
   <Layout image='/images/explore/explore.svg'>
     <Box className={`${classes.container}`}>
     <AuthHead action="Sign Up" description='Create account with your Email'/>
     <Box className={classes.input}>
       <NameInput name="Full Name" placeholder='Enter Full Name'/>
       <EmailInput/>
       <PasswordInput/>
       <PasswordInput name="Confirm Password" placeholder="Retype password"/>
       <CheckInput name="I agree with Arel Privacy Policy" isBtn={false}/>
       <BtnInput name="Sign Up"/>
       <DontHave actionName='Login' btnAction={()=>changeAuthType('login')}/>
     </Box>
    
     </Box>
   </Layout>
  )
}

const styles=makeStyles()((theme)=>({
    container:{
      backgroundColor:theme.colors.white,
      display:'flex',
      flexDirection:'column',
     width:'80%'
    },
    debug:{
        border:'1px solid green'
    },
    input:{
      display:'flex',
      flexDirection:'column',
      gap:theme.spacing(3) 
    }
}))